import { z } from 'zod';
export const SCAN_TIERS = ['free', 'paid', 'enterprise'];
export const SCAN_TRIGGERS = ['user', 'clawhub_bulk', 'api'];
const repoIdPattern = /^[A-Za-z0-9][A-Za-z0-9._-]*\/[A-Za-z0-9._-]+$/;
export const stageModelsSchema = z
    .object({
    stage0: z.string().min(1).optional(),
    stage1: z.string().min(1).optional(),
    stage2: z.string().min(1).optional(),
    stage3: z.string().min(1).optional(),
    stage4: z.string().min(1).optional(),
    stage5: z.string().min(1).optional(),
})
    .strict();
export const scanTaskContractSchema = z
    .object({
    scan_id: z.string().uuid(),
    repo_id: z
        .string()
        .regex(repoIdPattern, 'repo_id must be in "owner/name" GitHub format'),
    tier: z.enum(SCAN_TIERS),
    triggered_by: z.enum(SCAN_TRIGGERS),
    stage_models: stageModelsSchema.optional(),
    approval_required_before_merge: z.boolean(),
})
    .strict();
export function parseScanTaskContract(input) {
    return scanTaskContractSchema.parse(input);
}
//# sourceMappingURL=scan-task.js.map